import { render } from "./DefaultBtn.vue?vue&type=template&id=b3b0681c&scoped=true"
import script from "./DefaultBtn.vue?vue&type=script&lang=js"
export * from "./DefaultBtn.vue?vue&type=script&lang=js"

import "./DefaultBtn.vue?vue&type=style&index=0&id=b3b0681c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b0681c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg});
